import React from 'react';
import { ButtonRadio, Spinner, Modal } from '../Common';

export default class ConservationCare extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            conservation: this.props.data,
            displayModal: 'inactive',
            videoSpinner: 'inactive',
            error: {
                conservation: '',
            }
        }
    }

    handleOnChange = (key, e) => {
        const value = e.target.value;
        this.setState(() => ({ [key]: value }));
    }

    onSubmit = (e) => {
        e.preventDefault();
        const conservation = (!this.state.conservation) ? ' is-invalid' : '';
        this.setState(prevState => ({
            error: {
                ...prevState.error,
                conservation,
            }
        }))

        if (!conservation)
            this.props.onConservationCareSubmit(this.state.conservation);
    }


    render() {
        return (
                <form onSubmit={this.onSubmit} className="funeral-form">
                    <div className="row">
                        <div className="col-sm-5">
                            <img src='/images/soins-lg.png' alt="image profil" className="care _lg" />
                            <img src='/images/soins-sm.png' alt="image profil" className=" _sm" />
                        </div>
                        <div className="col-sm-7 form-container top-from padding-left">
                            <div className="form-group">
                                <h6>Avant la mise en bière, il est souvent conseillé mais non obligatoire de procéder à des soins de conservations.</h6>
                                <label>Je souhaite * :</label>
                                <ButtonRadio
                                    type="radio"
                                    _id="radiocc1"
                                    name="conservation"
                                    value="Une toilette simple"
                                    checked={this.state.conservation == "Une toilette simple"}
                                    onChange={this.handleOnChange.bind(this, "conservation")}
                                />
                                <ButtonRadio
                                    type="radio"
                                    _id="radiocc2"
                                    name="conservation"
                                    value="Une conservation par le froid"
                                    checked={this.state.conservation == "Une conservation par le froid"}
                                    onChange={this.handleOnChange.bind(this, "conservation")}
                                />
                                <ButtonRadio
                                    type="radio"
                                    _id="radiocc3"
                                    name="conservation"
                                    value="Une conservation chimique (thanatopraxie)"
                                    checked={this.state.conservation == "Une conservation chimique (thanatopraxie)"}
                                    onChange={this.handleOnChange.bind(this, "conservation")}
                                />
                            </div>
                        </div>
                        <div className="col-sm-12 form-container align-center">
                            <div className="required-txt"> * Champs obligatoires</div>
                            <div className="button-container">
                                <button className="btn btn-outline-primary" onClick={this.props.back}>Precedent</button>
                                <button type="submit" className="btn btn-primary">Suivant ></button>
                            </div>
                        </div>
                    </div>
                </form >
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/FuneralPage/ConservationCareForm.js